import { isPresetFreestyleToolId } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { FreestyleToolsStore, useCurrentWorkspace } from 'src/store';

const useFreestyleToolsState = createStateSelectorHook(FreestyleToolsStore, [
  'freestyleTools',
  'filteredFreestyleTools',
]);

export const useFreestyleTools = () => {
  const currentWorkspace = useCurrentWorkspace();
  const { freestyleTools } = useFreestyleToolsState();

  const presetFreestyleTools = freestyleTools?.filter((freestyleTool) =>
    isPresetFreestyleToolId(freestyleTool.id)
  );

  return [...(currentWorkspace?.associatedFreestyleTools || []), ...presetFreestyleTools];
};

export const useFilteredFreestyleTools = () => {
  const { filteredFreestyleTools } = useFreestyleToolsState();
  return filteredFreestyleTools;
};
